import { render, staticRenderFns } from "./template.vue?vue&type=template&id=6b83f416&scoped=true&"
import script from "./EditTrabajo.vue?vue&type=script&lang=js&"
export * from "./EditTrabajo.vue?vue&type=script&lang=js&"
import style0 from "./EditTrabajo.scss?vue&type=style&index=0&id=6b83f416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b83f416",
  null
  
)

export default component.exports